<template>
  <div class="authorization" >
    <div class="authorization__wrapper">
      <div class="authorization__left">
        <img
          :src="link"
          class="authorization__logo"
          :alt="app_name"
        />
        <p class="authorization__description">
          Комплексное решение для <br />
          найма персонала
        </p>
      </div>
      <AuthorizationForm />
    </div>
  </div>
</template>

<script setup>
  import AuthorizationForm from "@/components/AuthorizationForm";
  import { computed } from "vue";
  const link = computed(() => {
    return process.env.VUE_APP_LOGO_AUTH
  })
  const app_name = computed(() => {
    return process.env.VUE_APP_PRODUCT_NAME
  })

</script>

<style scoped lang="scss">
  .authorization {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: $bg_auth;
    background-size: 100%;
    background-position: right;
    background-repeat: no-repeat;

    &__wrapper {
      width: 100%;
      max-width: 1040px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__logo {
      width: 210px;
    }

    &__description {
      max-width: 381px;
      margin-top: 16px;
      font-size: 24px;
      font-weight: 400;
      line-height: 140%;
    }
  }
</style>
